"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryFilterControl = void 0;

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Check = function Check(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
  }));
};

Check.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "CategoryFilterControl__Wrapper",
  componentId: "sc-44vwtq-0"
})(["display:inline-block;"]);

var Button = _styledComponents.default.button.withConfig({
  displayName: "CategoryFilterControl__Button",
  componentId: "sc-44vwtq-1"
})(["box-sizing:border-box;width:35px;height:20px;padding:0;border:1px solid #ddd;border-radius:5px;margin-right:0.75em;background:none;cursor:pointer;user-select:none;line-height:18px;outline:none;&:active,&:hover{border-color:", ";}&:focus{box-shadow:0 0 0 0.2em ", ";}::-moz-focus-inner{border:0;}"], (0, _polished.darken)(0.15, '#ddd'), (0, _polished.transparentize)(0.5, '#ddd'));

var CheckboxIcon = _styledComponents.default.span.withConfig({
  displayName: "CategoryFilterControl__CheckboxIcon",
  componentId: "sc-44vwtq-2"
})(["position:relative;display:inline-block;box-sizing:border-box;width:14px;height:14px;padding:1px;border-width:1px;margin:0 0.7em;border-color:#000;border-radius:3px;border-style:solid;font-size:10px;> svg{position:absolute;top:1px;left:1px;width:10px;height:10px;}"]);

var Checkbox = _styledComponents.default.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "CategoryFilterControl__Checkbox",
  componentId: "sc-44vwtq-3"
})(["", ";:focus + ", "{border-color:#428bca;box-shadow:0 0 0 0.2em #428bca;}"], (0, _polished.hideVisually)(), CheckboxIcon);

var CategoryWrapper = _styledComponents.default.span.withConfig({
  displayName: "CategoryFilterControl__CategoryWrapper",
  componentId: "sc-44vwtq-4"
})(["display:inline-flex;flex-shrink:0;align-items:center;overflow:hidden;border-color:", ";border-style:solid;border-width:1px;&:first-child{border-top-left-radius:0.5em;border-bottom-left-radius:0.5em;}&:last-child{border-top-right-radius:0.5em;border-bottom-right-radius:0.5em;}@media (max-width:", "px){margin-bottom:0.25em;border-radius:0.5em;}"], function (props) {
  return props.borderColor;
}, function (props) {
  return props.verticalBreakpoint;
});

var background = function background(_ref) {
  var backgroundColor = _ref.backgroundColor;
  return "linear-gradient(to right, ".concat(backgroundColor, ", ").concat(backgroundColor, " 2em, rgba(0, 0, 0, 0) 2em, rgba(0, 0, 0, 0))");
};

var Label = _styledComponents.default.label.withConfig({
  displayName: "CategoryFilterControl__Label",
  componentId: "sc-44vwtq-5"
})(["display:inline-flex;flex-grow:1;align-items:center;background:", ";background-repeat:no-repeat;font-size:14px;user-select:none;"], background);

var LabelText = _styledComponents.default.span.withConfig({
  displayName: "CategoryFilterControl__LabelText",
  componentId: "sc-44vwtq-6"
})(["padding:0.375em 0.75em;"]);

var CategoryFilterControl = function CategoryFilterControl(_ref2) {
  var categories = _ref2.categories,
      categorySelections = _ref2.categorySelections,
      className = _ref2.className,
      id = _ref2.id,
      _onChange = _ref2.onChange,
      style = _ref2.style;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className,
    id: id,
    style: style
  }, categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement(CategoryWrapper, {
      key: category.id,
      borderColor: category.color,
      className: category.className
    }, /*#__PURE__*/_react.default.createElement(Label, {
      htmlFor: "".concat(id, "-").concat(category.id),
      backgroundColor: (0, _polished.transparentize)(0.5, category.color)
    }, /*#__PURE__*/_react.default.createElement(Checkbox, {
      checked: categorySelections[category.id],
      id: "".concat(id, "-").concat(category.id),
      type: "checkbox",
      onChange: function onChange(e) {
        return _onChange(_objectSpread(_objectSpread({}, categorySelections), {}, _defineProperty({}, category.id, e.target.checked)));
      }
    }), /*#__PURE__*/_react.default.createElement(CheckboxIcon, {
      "aria-hidden": true
    }, categorySelections[category.id] && /*#__PURE__*/_react.default.createElement(Check, null)), /*#__PURE__*/_react.default.createElement(LabelText, null, category.label)), /*#__PURE__*/_react.default.createElement(Button, {
      onClick: function onClick() {
        return _onChange(categories.reduce(function (acc, cat) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cat.id, cat.id === category.id));
        }, {}));
      }
    }, "only"));
  }));
};

exports.CategoryFilterControl = CategoryFilterControl;
CategoryFilterControl.propTypes = {
  categories: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    className: _propTypes.default.string,
    color: _propTypes.default.string.isRequired
  })).isRequired,
  categorySelections: _propTypes.default.objectOf(_propTypes.default.bool).isRequired,
  className: _propTypes.default.string,
  id: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  style: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))
};
CategoryFilterControl.defaultProps = {
  className: undefined,
  style: undefined
};